/**
 * Resolves a public asset path relative to Vite's base URL.
 *
 * In production/dev (base = "/"), this is a no-op.
 * In PR preview deployments (base = "/smartscribe-companion-apps/341/"),
 * this prefixes the path so assets load from the correct location.
 *
 * Usage: `<img src={publicAsset("/logo-128.png")} />`
 */
export function publicAsset(path: string): string {
  const base = import.meta.env.BASE_URL || '/';
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return base + cleanPath;
}
